import { CaseFieldValueEntity } from './case-field-value.entity';
import { CaseFileUploadEntity } from './case-file-upload.entity';
import { CaseAttachmentEntity } from './case-attachment.entity';

/**
 * Case domain entity.
 * Represents a Case in the system.
 * Priority codes are dynamic and defined by the priority-snapshots API endpoint.
 */
export class CaseEntity {
  public id!: string;
  public caseNumber!: string;
  public caseTypeId!: string;
  public caseTypeName!: string;
  public caseTypeCategoryName!: string;
  public caseFormVersionId!: string;
  public requestorUserId!: string;
  public requestedByUserId!: string;
  public requestedByName!: string;
  public requestedByEmail!: string;
  public requestedByPhone!: string;
  public requestedByDivision!: string | null;
  public requestedByDepartment!: string | null;
  public priorityCode!: string;
  public priorityName!: string;
  public primaryAssigneeUserId!: string | null;
  public primaryAssigneeName!: string | null;
  public secondaryAssigneeUserId!: string | null;
  public secondaryAssigneeName!: string | null;

  // Initialize arrays with default empty arrays to prevent undefined errors
  public involvedEmployeeIds: string[] = [];
  public fieldValues: CaseFieldValueEntity[] = [];
  public fileUploads: CaseFileUploadEntity[] = [];
  public attachments: CaseAttachmentEntity[] = [];

  public statusCategoryId!: number;
  public statusCategoryName!: string;
  public statusColor!: string;
  public statusDisplayName!: string;
  public statusId!: string;
  public statusName!: string;
  public dueDate!: string | null;
  public createdByUserName!: string;
  public createdOn!: string;
  public updatedOn!: string;

  // Closing fields (populated when case is closed/resolved)
  public closingReasonId!: string | null;
  public closingReasonName!: string | null;
  public closingNotes!: string | null;
  public closedOn!: string | null;
  public closedByUserId!: string | null;
  public closedByUserName!: string | null;

  public isReadOnly!: boolean;
  public workflowSubStatus!: string | null;
  public currentWorkflowStepName!: string | null;
  public currentWorkflowStepType!: string | null;
  public currentWorkflowHandoffTeamName!: string | null;
  public currentWorkflowHandoffTargetUserName!: string | null;
  public currentWorkflowHandoffDistributionMethod!: string | null;
}
